import { render, staticRenderFns } from "./PartnerListing.vue?vue&type=template&id=8197d798&scoped=true&"
import script from "./PartnerListing.vue?vue&type=script&lang=js&"
export * from "./PartnerListing.vue?vue&type=script&lang=js&"
import style0 from "./PartnerListing.vue?vue&type=style&index=0&id=8197d798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8197d798",
  null
  
)

export default component.exports